import React from 'react';
import { useTransition, animated } from 'react-spring';

export interface ProgressIndicatorAnimationProps {
  fade?: boolean;
  disableAnimation?: boolean;
  children: React.ReactNode;
}

const ProgressIndicatorAnimation:React.FC<ProgressIndicatorAnimationProps> = (({
  children,
  fade,
  disableAnimation,
}: ProgressIndicatorAnimationProps) => {
  const transitions = useTransition(!fade, null, {
    from: { opacity: 1 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 300 },
    immediate: disableAnimation,
  });
  return (
    <>{transitions.map(({ item, key, props }) => (
      item && (
        <animated.div key={key} style={props}>
          {children}
        </animated.div>
      )))}
    </>
  );
});

ProgressIndicatorAnimation.defaultProps = {
  fade: false,
  disableAnimation: undefined,
};
ProgressIndicatorAnimation.displayName = 'ProgressIndicatorAnimation';
export default ProgressIndicatorAnimation;